import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component } from "@angular/core";
import { NavController, NavParams, Platform } from "ionic-angular";
import { AlertController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Member } from "../../models/interfaces/member.model";
import { PrivilegeRole } from "../../models/interfaces/privilegerole.model";
import { SettingsAddPage } from "../../pages/settings/settings_add";
import { SettingsUpdatePage } from "../../pages/settings/settings_update";
import { AuthService } from "../../providers/dbservice/authservice";
import { ConfigService } from "../../providers/dbservice/configservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";

@Component({
  selector: "page-settings",
  templateUrl: "settings.html",
})

export class SettingsPage {
  public static readonly SETTINGS_VIEW_ACCESS = "viewSettings";
  public static readonly SETTINGS_ADD_ACCESS = "addSettings";
  public static readonly SETTINGS_UPD_ACCESS = "updateSettings";
  public static readonly SETTINGS_DEL_ACCESS = "deleteSettings";
  // public static readonly MEMBER_VIEW_ACCESS = "viewMember";
  private hasUpdateSettingsAccess: boolean = false;
  private hasInsertSettingsAccess: boolean = false;
  private hasDeleteSettingsAccess: boolean = false;
  private hasViewSettingsAccess: boolean = false;
  private settings_expenses$: any;
  private settings_payment: any;
  private settings_guest: any;
  private settings_pledge: any;
  private settings_shirt: any;
  private member$: any;
  private privilegerole$: any;
  private member: Member;
  private tmpSearchObject;
  private memberstatus: string = "Regulars";
  private styleName: string ="";
  // This property will save the callback which we can unsubscribe when we leave this view
  constructor(public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    public alertCtrl: AlertController, private db: DbserviceProvider, private configService: ConfigService,
    private platform: Platform,
  ) {
    console.log("SettingsPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");

  }
  private ionViewWillEnter() {
    console.log("SettingsPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("SettingsPage onInitPage");
    if (this.authService.currentUser) {
      this.hasUpdateSettingsAccess = this.db.hasAccess(SettingsPage.SETTINGS_UPD_ACCESS);
      this.hasViewSettingsAccess = this.db.hasAccess(SettingsPage.SETTINGS_VIEW_ACCESS);
      this.hasInsertSettingsAccess = this.db.hasAccess(SettingsPage.SETTINGS_ADD_ACCESS);
      this.hasDeleteSettingsAccess = this.db.hasAccess(SettingsPage.SETTINGS_DEL_ACCESS);
    }

    this.settings_expenses$ = this.db.dbCol({
      "action": "select", "mapObject": "settings",
      "sqlExtended": " where se_class = 'Expenses' order by se_class,se_order",
    });


    this.db.dbCol({
      "action": "select", "mapObject": "settings",
      "sqlExtended": " where se_class = 'Guest' order by se_class,se_order",
    }).subscribe((set) => {
      this.settings_guest = set;
    });

    this.db.dbCol({
      "action": "select", "mapObject": "settings",
      "sqlExtended": " where se_class = 'Payment' order by se_class,se_order",
    }).subscribe((set) => {
      this.settings_payment = set;
    });

    this.db.dbCol({
      "action": "select", "mapObject": "settings",
      "sqlExtended": " where se_class = 'Pledge' order by se_class,se_order",
    }).subscribe((set) => {
      this.settings_pledge = set;
    });

    this.db.dbCol({
      "action": "select", "mapObject": "settings",
      "sqlExtended": " where se_class = 'Member' order by se_order",
    }).subscribe((set) => {
      this.settings_shirt = set;
    });

  }

  private ngOnDestroy() {
    console.log("SettingsPage ngOnDestroy");
  }

  private updateSettings(setting: any ) {
    console.log("SettingsPage updateSettings");
    this.navCtrl.push(SettingsUpdatePage, { "settings": setting });
  }

  private deleteSettings(setting: any) {
    console.log("SettingsPage deleteHareline");
    this.showConfirm("Settings", "Do you want to delete this Setting?", setting);
  }

  private showConfirm(title: string, message: string, setting: any) {
    console.log("SettingsPage showConfirm");
    let confirm = this.alertCtrl.create({
      "buttons": [
        {
          "handler": () => {
            this.db.dbCol({
              "action": "dml", "mapObject": "dml",
              "query": "DELETE FROM settings WHERE expenses.se_id=" + setting.se_id,
            })
              .subscribe((ret) => {
                this.onInitPage();
              });
          },
          "text": "Yes",
        },
        {
          "handler": () => {
          },
          "text": "No",
        },
      ],
      "message": message,
      "title": title,
    });
    confirm.present();
  }

  private addSettings() {
    console.log("SettingsPage addSetting");
    this.navCtrl.push(SettingsAddPage);
  }
}




// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts